import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const StyledTabsLinks = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    background-color: ${({ theme }) => theme.colors.whiteSmoke};
    :after {
        content: '';
        position: absolute;
        left: 40px;
        right: 40px;
        bottom: -1px;;
        height: 1px;
        background-color: ${({ theme }) => theme.colors.mediumGrey};
    }
`;

export const StyledTabs = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const StyledTabNavLink = styled(NavLink)`
    ${({ theme }) => theme.fonts.mulishLight};
    font-size: 14px;
    line-height: 1em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.dimGrey};
    padding: ${props => props.small ? "25px" : "25px 40px"} ;
    text-decoration: none;
`;

export const StyledIndicator = styled.span`
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.purple};
    transition: all 0.3s;
    z-index: 1;
`;